import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SuperUserApiModel, SuperUserProfileApiModel, SuperUserProfileSelectorsApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class SuperUsersService {
  public apiUrl = 'super-users';

  constructor(private http: HttpClientService) {}

  public getList(): Observable<Array<SuperUserApiModel>> {
    return this.http
      .get<Array<SuperUserApiModel>>(`${this.apiUrl}/get-list`)
      .pipe(map((array) => array.map((x) => new SuperUserApiModel().deserialize(x))));
  }

  public getSelectors(): Observable<SuperUserProfileSelectorsApiModel> {
    return this.http.get<SuperUserProfileSelectorsApiModel>(`${this.apiUrl}/selectors`);
  }

  public add(model: SuperUserProfileApiModel): Observable<SuperUserProfileApiModel> {
    return this.http.post<SuperUserProfileApiModel>(`${this.apiUrl}/add`, model);
  }

  public update(model: SuperUserProfileApiModel): Observable<SuperUserProfileApiModel> {
    return this.http.put<SuperUserProfileApiModel>(`${this.apiUrl}/update`, model);
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
  }
}
